import {
  type IMCAttributionWindowDays,
  type INBAccountingMode,
} from "@north-beam/nb-common";

import { type SalesMetricV2 } from "../types";

export function makeCustomers({
  accountingMode,
  attributionWindow,
}: {
  accountingMode: INBAccountingMode;
  attributionWindow: IMCAttributionWindowDays;
}): SalesMetricV2 {
  const id = "customers";

  return {
    id,
    name: "Customers",
    fullName:
      "Customers / All" +
      (accountingMode === "accrual" ? ` (${attributionWindow}d)` : ""),
    description: "Customers",
    category: "northbeam",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
    isDashboardV2: true,
  };
}

export function makeCustomersFt({
  accountingMode,
  attributionWindow,
}: {
  accountingMode: INBAccountingMode;
  attributionWindow: IMCAttributionWindowDays;
}): SalesMetricV2 {
  const id = "customersFt";

  return {
    id,
    name: "New Customers",
    fullName:
      "Customers / New" +
      (accountingMode === "accrual" ? ` (${attributionWindow}d)` : ""),
    description: "New Customers",
    category: "northbeam",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
    isDashboardV2: true,
  };
}

export function makeCustomersRtn({
  accountingMode,
  attributionWindow,
}: {
  accountingMode: INBAccountingMode;
  attributionWindow: IMCAttributionWindowDays;
}): SalesMetricV2 {
  const id = "customersRtn";

  return {
    id,
    name: "Returning Customers",
    fullName:
      "Customers / Ret" +
      (accountingMode === "accrual" ? ` (${attributionWindow}d)` : ""),
    description: "Returning Customers",
    category: "northbeam",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
    isDashboardV2: true,
  };
}

export function makeCustomersFtRtn({
  accountingMode,
  attributionWindow,
}: {
  accountingMode: INBAccountingMode;
  attributionWindow: IMCAttributionWindowDays;
}): SalesMetricV2 {
  const id = "customersFtRtn";

  return {
    id,
    name: "New Customers that Repurchased",
    fullName:
      "Customers / New Customers that Repurchased" +
      (accountingMode === "accrual" ? ` (${attributionWindow}d)` : ""),
    description: "New Customers that Repurchased",
    category: "northbeam",
    positiveTrend: "up",
    format: "decimal",
    getValue(metrics) {
      return metrics[id];
    },
    isDashboardV2: true,
  };
}
